import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  GET_DAILY_EXPENSE,
  GET_DAILY_EXPENSE_BY_ID,
  GET_STATIONARY_LIST,
  GET_SUPPLIERS_LIST,
} from '../graphql/purchase.queries';
import {
  CREATE_DAILY_EXPENSE,
  REMOVE_DAILY_EXPENSE,
  UPDATE_DAILY_EXPENSE,
} from '../graphql/purchase.mutation';

@Injectable({
  providedIn: 'root',
})
export class PurchaseService {
  constructor(private apollo: Apollo) {}

  fetchDailyExpense(search: string = ''): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_DAILY_EXPENSE,
        variables: { search },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.dailyExpenses || []));
  }

  fetchSuppliers(search: string = ''): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_SUPPLIERS_LIST,
        variables: { search },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.suppliers || []));
  }

  fetchStationaryItems(search: string = ''): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_STATIONARY_LIST,
        variables: { search },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.stationories || []));
  }

  createExpense(
    createDailyExpenseInput: any,
    createDailyExpenseItemsInputs: any[]
  ): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: CREATE_DAILY_EXPENSE,
      variables: {
        createDailyExpenseInput,
        createDailyExpenseItemsInputs,
      },
    });
  }

  fetchDailyExpenseById(id: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .query<any>({
        query: GET_DAILY_EXPENSE_BY_ID,
        variables: {
          id,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result) => result.data?.dailyExpense || []));
  }

  updateDailyExpense(
    updateDailyExpenseInput: any,
    updateDailyExpenseItemInputs: any[]
  ): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: UPDATE_DAILY_EXPENSE,
      variables: {
        updateDailyExpenseInput,
        updateDailyExpenseItemInputs,
      },
    });
  }

  deleteDailyExpense(id: number): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: REMOVE_DAILY_EXPENSE,
      variables: { id },
    });
  }
}
